import React, { FC, PropsWithChildren, useMemo, useState } from 'react';
import styles from './styles.module.scss';
import cn from 'classnames';
import { TableProps } from 'react-bootstrap/Table';
import { ExpandableTableContext } from './ExpandableTableContext';
import { WidgetTable } from '../widget-table/WidgetTable';

interface IExpandableTableProps extends TableProps {
  total: number;
  previewRowsCount?: number;
}

const COLLAPSED_ROWS_COUNT_DEFAULT = 5;

export const ExpandableWidgetTable: FC<PropsWithChildren<IExpandableTableProps>> = ({
  total,
  children,
  className,
  previewRowsCount = COLLAPSED_ROWS_COUNT_DEFAULT,
  ...props
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const expandable = total > previewRowsCount;

  const context = useMemo(() => {
    if (expandable) {
      return { rowsCount: isExpanded ? null : previewRowsCount };
    }

    return { rowsCount: null };
  }, [isExpanded, expandable, previewRowsCount]);

  return (
    <ExpandableTableContext.Provider value={context}>
      <WidgetTable {...props}>{children}</WidgetTable>

      {expandable && (
        <div className={cn(styles.show_all_button__container)}>
          <button className={cn(styles.show_all_button)} type="button" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Скрыть' : 'Показать все'}
          </button>
        </div>
      )}
    </ExpandableTableContext.Provider>
  );
};
